import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import LoadingOverlay from './LoadingOverlay';
import { hasPermission, getAccessToken, redirectToLogin, isTokenExpired, refreshAccessToken, setTokenFromURL } from '../utils/auth';

const ProtectedRoute = ({ requiredPermission, children }) => {
  // console.log('children: ', children);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      setTokenFromURL();
      let token = getAccessToken();
      if (!token || isTokenExpired(token)) {
        token = await refreshAccessToken();
        if (!token) {
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
      }

      setIsAuthenticated(true);
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return <LoadingOverlay loading={isLoading} setLoading={setIsLoading} />;
  }

  if (!isAuthenticated) {
    redirectToLogin();
  }

  if (!hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <>
      {children}
    </>
  );
};

export default ProtectedRoute;